import React, { Component } from 'react';
import { connect } from 'react-redux'

import Navigation from './Navigation';

class AppStack extends Component {

	constructor(props){

		super(props);

  }

	render(){

		return (

			<div className={'appstack ' + this.props.className}>

				<Navigation />

				<div className="app-body">

					{this.props.children}

				</div>

			</div>
		);

	}

}

const mapStateToProps = (state) => {
	return { user: state.User };
}

const mapDispatchToProps = (dispatch) => {
	return {}
}


export default connect(mapStateToProps,mapDispatchToProps)(AppStack)



// WEBPACK FOOTER //
// ./src/Components/AppStack.js